@import 'common/component';
@import 'forms/reset/button';

:host {
  display: block;

  ::slotted(div[slot='heading']),
  .o2-tab__heading {
    font-size: $font-size-base;
    line-height: 2.1rem;
  }

  .o2-tab {
    position: relative;
    transition: all 0.2s ease-in-out;
    background: transparent;
    @include font-weight(600);
    letter-spacing: 0.015rem;
    color: var(--o2-secondary, #{$secondary});
    padding: 0 1.6rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 6rem;
    border: 0;
    width: 100%;

    @media (min-width: 768px) {
      height: 7rem;
    }

    &:hover {
      outline: 0;
      color: var(--o2-blue-action-dark, #{$blue-action-dark});
    }
  }

  .o2-tab.o2-tab--underline {
    height: auto;
    @include font-weight(400);
    letter-spacing: 0.03rem;
    color: var(--o2-black, #{$black});
    padding: 1.6rem 2.4rem;
    border-bottom: 0.3rem solid transparent;

    &:hover {
      outline: 0;
      color: var(--o2-blue-action, #{$blue-action});
    }
  }
}

:host([selected]) {
  .o2-tab {
    color: var(--o2-blue-brand, #{$blue-brand});
    cursor: default;
  }

  .o2-tab.o2-tab--underline {
    @include font-weight(400);
    letter-spacing: 0.015rem;
    color: var(--o2-blue-action, #{$blue-action});
    border-bottom: 0.3rem solid var(--o2-blue-action, #{$blue-action});

    .o2-tab__heading {
      color: var(--o2-blue-action, #{$blue-action});
    }
  }
}

:host(.o2-swiper__slide) {
  width: auto !important;
}
